module.exports = __webpack_public_path__ + "img/similar.3cf90905.svg";